import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../core'

export const RESOURCE = {
  payload: {
    description:
      'Jira tasks, the unit of work every pull request, spec and result traces back to.',
    name: 'Requirements',
    partialId: PartialId.Standard.create('requirements'),
  },
  type: core.quiver.Resource.Type.DmsDimension,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsDimension>
